"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GameActions = void 0;
class GameActions {
    static isCreateGame(a) {
        return a.tag === 'creategame';
    }
    static isStartPlay(a) {
        return a.tag === 'startplay';
    }
    static isResetPlay(a) {
        return a.tag === 'resetplay';
    }
    static isPausePlay(a) {
        return a.tag === 'pauseplay';
    }
    static isEndGame(a) {
        return a.tag === 'endgame';
    }
}
exports.GameActions = GameActions;
GameActions.CreateGame = {
    tag: 'creategame',
};
GameActions.StartPlay = {
    tag: 'startplay',
};
GameActions.ResetPlay = {
    tag: 'resetplay',
};
GameActions.PausePlay = {
    tag: 'pauseplay',
};
GameActions.EndGame = {
    tag: 'endgame',
};
//# sourceMappingURL=GameStateAction.js.map